import React from 'react'

export default function Header () {
  
  return (
    <div className="header bg-gradient-info pb-8 pt-5 pt-md-8" />
  )
}